import type { CancellationFlowConfig } from '../types/subscription-cancellation.types';

export const CANCELLATION_FLOWS: Record<SubscriptionCancellationSituation, CancellationFlowConfig> =
  {
    'no-plans-created': {
      headline: "We noticed you haven't completed a test plan yet.",
      body: "You haven't experienced how Waterlily works yet. We can show you how to create and share a plan in under 5 minutes. No work required from you.\n\nThen you can invite clients to create their LTC plans.",
      primaryCta: 'Create Quick Plan',
      explainerVideoUrl: 'https://www.loom.com/embed/90255565dc404610846adecbd7d82049',
    },
    'only-self-plan': {
      headline: "You haven't had clients complete a plan yet",
      body: "You're close to seeing the magic of Waterlily. \nInvite your clients to fill out the same LTC application you did. Just provide their emails and we do the rest.\n\nMost advisors see a high completion rate within days.",
      primaryCta: 'Invite Clients',
      explainerVideoUrl: 'https://www.loom.com/embed/90255565dc404610846adecbd7d82049',
    },
    'created-not-reviewed': {
      headline: "You haven't viewed your client results",
      body: "You're close to real value. \nYour clients completed their LTC applications but you haven't reviewed their results.\n\nAdvisors see the biggest payoff after reviewing client results and then walking clients through their funding options.",
      primaryCta: 'View Client Plans',
      explainerVideoUrl: 'https://www.loom.com/embed/ba5e6a8ee0ea43af948f2b3f9acd3cc6',
    },
    'reviewed-not-shared': {
      headline: "You haven't shared your client results",
      body: "You're so close to real value. \nYour clients completed their LTC applications but you haven't shared their results.\n\nAdvisors see the biggest payoff after sharing LTC results and walking them through their funding options.",
      primaryCta: 'Share Client Plans',
      explainerVideoUrl: 'https://www.loom.com/embed/ba5e6a8ee0ea43af948f2b3f9acd3cc6',
    },
    'low-engagement': {
      headline: "You're using Waterlily correctly. \nNow you need to scale up",
      body: "You've already created and shared a few LTC plans. \nNow it's time to ramp up!\n\nMost advisors see the strongest return once they've worked 10+ applications through Waterlily.\n\nWe recommend inviting more clients, or contact us if you need help using Waterlily.",
      primaryCta: 'Invite Clients',
      explainerVideoUrl: 'https://www.loom.com/embed/90255565dc404610846adecbd7d82049',
    },
    'high-engagement': {
      headline: "You're using Waterlily correctly.",
      body: 'Advisors who reach your stage tell us Waterlily helped them immensely by:\n\n• Structuring more confident LTC conversations\n• Standardizing how they evaluate funding options\n• Streamlining next steps when clients are ready to move forward\n\nIf you are not experiencing the same value let us know how we can help.',
      primaryCta: 'Contact Waterlily',
    },
  };
